/**
 * Constants Values for Navigation
 */
export const Navigation = {
    Dashboard: '/dashboard',
    Map: '/map',
    MapLeaflet: '/map',
    Gantt: '/gantt',
    MainKPI: '/main-kpi',
    Lookup:'/lookup',
    Landing: '/dashboard'
}